import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
    return (_openBlock(), _createElementBlock("div", {
      key: i,
      onClick: ($event: any) => (_ctx.onClick(tab)),
      class: _normalizeClass([[_ctx.stateClasses(tab)], "flex justify-between items-center"])
    }, [
      _createTextVNode(_toDisplayString(tab.label) + " ", 1),
      (_ctx.isActiveTab(tab))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: require('@/embr/assets/images/check.png')
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1))
  }), 128))
}